import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full acontent" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("titles.ml_create_template"))),
      ]),
      _vm._t("default"),
      _c("actions-component"),
      _c(
        VCard,
        [
          _c(
            VCardText,
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("data_quality.dataplex.quality.fields.name")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "4" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          dense: "",
                          outlined: "",
                          filled: _vm.view,
                          disabled: _vm.view,
                        },
                        on: { keyup: _vm.onChangeName },
                        model: {
                          value: _vm.template.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.template, "name", $$v)
                          },
                          expression: "template.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Versión")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "4" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          filled: "",
                          readonly: "",
                          dense: "",
                          outlined: "",
                          disabled: _vm.view || _vm.edit,
                        },
                        model: {
                          value: _vm.template.version,
                          callback: function ($$v) {
                            _vm.$set(_vm.template, "version", $$v)
                          },
                          expression: "template.version",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "data_quality.dataplex.quality.fields.description"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "10" } },
                    [
                      _c(VTextarea, {
                        attrs: {
                          filled: _vm.view,
                          dense: "",
                          outlined: "",
                          disabled: _vm.view,
                          rows: 2,
                          hint: "(Opcional)",
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.template.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.template, "description", $$v)
                          },
                          expression: "template.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }